export interface RoutePoint {
  latitude: number;
  longitude: number;
}

export interface RouteResponse {
  path: RoutePoint[];
  distance: number;
  duration: number;
}

declare global {
  interface Window {
    google: any;
  }
}

export const getRouteDirections = async (
  origin: RoutePoint,
  destination: RoutePoint,
): Promise<RouteResponse | null> => {
  if (!window.google || !window.google.maps) {
    return null;
  }

  try {
    const directionsService = new window.google.maps.DirectionsService();

    return new Promise((resolve) => {
      directionsService.route(
        {
          origin: new window.google.maps.LatLng(origin.latitude, origin.longitude),
          destination: new window.google.maps.LatLng(destination.latitude, destination.longitude),
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result: any, status: any) => {
          if (status === window.google.maps.DirectionsStatus.OK && result) {
            const path: RoutePoint[] = [];
            let totalDistance = 0;
            let totalDuration = 0;

            result.routes[0].legs.forEach((leg: any) => {
              totalDistance += leg.distance.value;
              totalDuration += leg.duration.value;

              leg.steps.forEach((step: any) => {
                step.path.forEach((point: any) => {
                  path.push({
                    latitude: point.lat(),
                    longitude: point.lng(),
                  });
                });
              });
            });

            resolve({
              path,
              distance: totalDistance / 1000, 
              duration: totalDuration / 60, 
            });
          } else {
            resolve(null);
          }
        }
      );
    });
  } catch (error) {
    console.error('Error getting directions:', error);
    return null;
  }
};
